import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

export const commonMessage = {
  get emailError(): string {
    return t('common.error.email');
  },
  emailMaxLimitError: (limit: number): string =>
    t('common.error.emailMaxLimit', { limit }),
  get licenseError(): string {
    return t('common.error.chooseLicense');
  },
  get phoneNumberError(): string {
    return t('common.error.invalidPhoneNumber');
  },
  requiredField: (fieldName: string): string =>
    t('common.error.requiredField', { fieldName }),
  lengthError: (length: number): string => t('common.error.length', { length }),
  lengthValidationError: (fieldName: string, length: number): string =>
    t('common.error.lengthValidation', { fieldName, length }),
  emailLengthError: (
    fieldName: string,
    length: number,
    localLength: number,
  ): string =>
    t('common.error.emailLength', { fieldName, length, localLength }),
  quantityError: (min: number, max: number): string =>
    t('common.error.quantity', { min, max }),
};
